import {
  ElementRef,
  Input,
  Component,
  OnInit,
  SecurityContext,
} from '@angular/core'
import { AuthService } from '../_services'
import { HttpClient } from '@angular/common/http'
import { environment } from 'environments/environment'

import { Broadcaster } from 'environments/broadcaster'

import { Subscription } from 'rxjs/Subscription'
import { LoaderService } from '../_services/loader.service'

import { DomSanitizer } from '@angular/platform-browser'

import * as firebase from 'firebase'
import { MomentDateAdapter } from '@angular/material-moment-adapter'
import * as _moment from 'moment'
import * as _rollupMoment from 'moment'

const moment = _rollupMoment || _moment
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

declare var $: any
declare var google: any
// declare var firebase: any;

@Component({
  selector: 'new-consumer',
  templateUrl: 'newConsumer.component.html',
})
export class NewConsumerDirective implements OnInit {
  percentage = 0
  value = ''
  downloadURL
  backgroundImage
  loading = false
  public percentMtr = false
  public onUploadComplete = false

  public busy: Subscription
  @Input() consumer: any
  public showLoader: boolean
  public consumers: any
  map: any
  prjID: any
  userId: any
  consumerCode: any
  city: any
  refID: any
  consumerName: any
  consumerCD: any
  buildingID: any
  buildingName: any
  ownerName: any
  houseNo: any
  street: any
  //locality:any
  state: any
  landmark: any
  address: any
  shipAddress: any
  pin: any
  mobileNo: any
  email: any
  bldTypeID: any
  BldTypName: any
  buildingCategoryId: any
  buildingCategoryName: any
  UccCategoryID: any
  catCD: any
  UCCCategory: any
  area: any
  UOM: any
  stdRate: any
  agreedRate: any
  uomDataModal: any
  billType: any
  verifyStatus: any
  //billStartDt: any
  buildingCatogery: any
  buildCatId: any
  buildingCatogeryType: any
  uccType: any
  UccId: any
  uomType: any
  ddlZoneData: any
  ddlWordData: any
  ddlZoneModel: any
  latitudeModal: any
  longitudeModal: any
  gstinModal: any
  public ddlUomTypModal: any
  public ddlWardModel: any
  public empUploadImgModel: any
  public search: any
  public entityCodeLoaderDiv = false
  public imgLoaderPath: any
  public billTypeJsonData: any
  public InvoiceTypeJsonData: any
  public billingTypeModal: any
  public invoiceTypeModal: any
  public verifyStatusData: any
  public verifiedStatusModal: any
  public crmLocationsData: any
  public lat: any
  public lng: any
  public crmLocations: any
  public consumerLocanotFound = false
  public imgCrmPath: any
  public crmLoaderDiv = false
  public consuSuccessMsg = false
  public chkConsumerEmailAddress = false
  isConsuSavebtn = false
  chkConsumerNameAddress = false
  //emailRequired=false;
  consuErrorMsg = false
  requiredBldCategory = false
  requiredUccCategory = false
  requiredZone = false
  requiredWard = false
  public totalAgreedRate: any
  public agreedRateValid = false
  public agrValue: any
  public billStartDt: any
  public mouExpiryDate: any
  public requiredBillType = false
  public requiredInvoiceType = false
  public requiredVeriFiedStatus = false
  public agreedRateRequired = false
  public areaRequired = false
  public billDateRequired = false
  public mouExpiryDateRequired = false
  public addressRequired = false
  public proAgreedRate: any
  public monthlychargesValid = false
  public proMonthlyCharge: any
  isService: any
  isBillable: any
  isTaxable: any

  employeList: any
  clientManager: any
  distributionManager: any
  serviceManager: any
  altMobileNo: any
  filePath: any
  poNumber: any
  poDate: any
  pan: any

  public MData = [
    { months: 'January', value: '01' },
    { months: 'February', value: '02' },
    { months: 'March', value: '03' },
    { months: 'April', value: '04' },
    { months: 'May', value: '05' },
    { months: 'June', value: '06' },
    { months: 'July', value: '07' },
    { months: 'August', value: '08' },
    { months: 'September', value: '09' },
    { months: 'October', value: '10' },
    { months: 'November ', value: '11' },
    { months: 'December', value: '12' },
  ]
  public gstMonths: any = 'true'
  isCheckedGST: any
  monthsModal: any
  currentYear: string
  gstTaxableMonths: string

  constructor(
    private broadcaster: Broadcaster,
    private _el: ElementRef,
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private domSanitizer: DomSanitizer,
  ) {
    this.broadcaster.on('addnewConsumer').subscribe((message) => {
      if (message) {
        $('#ConsumerModal').modal('show')
        this.editConsumer(message)
        this.billTypeDetails()
        this.invoiceTypeDetails()
        this.billingTypeModal = this.billTypeJsonData[1].ID
        this.invoiceTypeModal = this.InvoiceTypeJsonData[1].ID
        this.consuErrorMsg = false
        this.consuSuccessMsg = false
        // console.log(message)
      } else {
        $('#ConsumerModal').modal('show')
        this.clearConsumerData()
        this.getConsumersCode()
        this.getZoneByProject()
        this.billTypeDetails()
        this.invoiceTypeDetails()
        this.billingTypeModal = this.billTypeJsonData[1].ID
        this.invoiceTypeModal = this.InvoiceTypeJsonData[1].ID
        this.verifiedStatusModal = this.verifyStatusData[1].ID
        this.consuErrorMsg = false
        this.consuSuccessMsg = false
      }
    })
    this.consuErrorMsg = false
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
  }

  /*
   ** To bind UOM details Data
   */
  public billTypeDetails() {
    this.billTypeJsonData = [
      {
        ID: 1,
        VALUE: 'Direct',
      },
      {
        ID: 2,
        VALUE: 'Invoice',
      },
    ]
  }

  /*
   ** To bind UOM details Data
   */
  public invoiceTypeDetails() {
    this.InvoiceTypeJsonData = [
      {
        ID: 1,
        VALUE: 'Tax Invoice',
      },
      {
        ID: 2,
        VALUE: 'Performa Invoice',
      },
    ]
  }

  /*
    To bind UOM details Data
 */
  public verifyStatusDetails() {
    this.verifyStatusData = [
      {
        ID: 1,
        VALUE: 'Verified',
      },
      {
        ID: 2,
        VALUE: 'Unverified',
      },
    ]
  }

  // image upload
  // detectFiles($event) {
  //   // debugger;
  //   // firebase connectivity for image upload
  //   var config = {
  //     authDomain: "ecogreen-citizen-app.firebaseapp.com",
  //     apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
  //     databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
  //     storageBucket: 'ecogreen-citizen-app.appspot.com',
  //     projectId: 'ecogreen-citizen-app'
  //   };

  //   firebase.initializeApp(config);

  //   this.percentMtr = true;

  //   this.percentage = 0;

  //   // get file
  //   const file1 = $event.target.files[0];

  //   // create storage ref
  //   const storageRef = firebase.storage().ref('/MOU/' + this.consumerCD);
  //   // console.log("FILENAME", file1.name);
  //   // Upload file
  //   const task = storageRef.put(file1);

  //   // Upload progress bar
  //   task.on('state_changed',
  //     (snapshot: any) => {
  //       this.percentage = (task.snapshot.bytesTransferred / task.snapshot.totalBytes) * 100;
  //       // console.log(this.percentage);
  //       this.percentMtr = true;

  //       if (this.percentage == 100) {
  //         this.onUploadComplete = true
  //       }
  //     },
  //     (error) => {
  //       console.error(error);
  //       this.percentMtr = false;
  //     },
  //     () => {
  //       storageRef.getDownloadURL().then((downloadURL) => {
  //         this.downloadURL = downloadURL;
  //         // console.log("This is download URL", downloadURL);
  //         this.backgroundImage = (this.downloadURL && this.downloadURL != null && this.downloadURL !== '')
  //           ? this.domSanitizer.sanitize(SecurityContext.STYLE, 'url(' + this.downloadURL + ')')
  //           : this.domSanitizer.sanitize(SecurityContext.STYLE, 'none');
  //         // this.onChange(downloadURL);
  //       },
  //         (error) => {
  //           console.error('upload rejected', error);
  //           this.percentMtr = false;
  //         });
  //     }
  //   );
  // }

  AddConsumerModal() {
    this.clearConsumerData()
    $('#ConsumerModal').modal('show')
  }
  clearConsumerData() {
    this.refID = null
    this.consumerName = null
    this.consumerCD = null
    this.buildingID = null
    this.buildingName = null
    this.ownerName = null
    this.houseNo = null
    this.street = null
    //this.locality=null
    this.state = null
    this.landmark = null
    this.address = null
    this.shipAddress = null
    this.gstinModal = null
    this.poNumber = null
    this.poDate = null
    this.pan = null
    this.latitudeModal = null
    this.longitudeModal = null
    this.city = null
    this.pin = null
    this.mobileNo = null
    this.altMobileNo = null
    this.email = null
    this.bldTypeID = null
    this.BldTypName = null
    this.buildingCategoryId = null
    this.buildCatId = null
    this.buildingCategoryName = null
    this.UccCategoryID = null
    this.catCD = null
    this.UCCCategory = null
    this.area = null
    this.UOM = null
    this.stdRate = null
    this.agreedRate = null
    this.billType = null
    this.verifyStatus = null
    this.billStartDt = null
    this.mouExpiryDate = null
    this.addressRequired = false
    this.billDateRequired = false
    this.mouExpiryDateRequired = false
    this.ddlZoneModel = null
    this.ddlWardModel = null
    this.filePath = null
    this.requiredZone = false
    this.requiredWard = false
    this.agreedRateValid = false
    this.monthlychargesValid = false
    this.areaRequired = false
    this.agreedRate = ''
    this.totalAgreedRate = ''
    this.proMonthlyCharge = ''
    this.proAgreedRate = ''
    this.uomDataModal = ''
  }
  editConsumer(consumer) {
    console.log(consumer)
    this.empUploadImgModel = null
    this.percentMtr = false
    this.isConsuSavebtn = false
    this.onUploadComplete = false
    this.clearConsumerData()
    this.billTypeDetails()
    this.invoiceTypeDetails()
    this.getBuildingType()
    this.billingTypeModal = this.billTypeJsonData[0].ID
    this.invoiceTypeModal = this.InvoiceTypeJsonData[0].ID
    this.refID = consumer.refID
    this.consumerName = consumer.consumerName
    this.consumerCD = consumer.consumerCD
    this.buildingID = consumer.buildingID
    this.bldTypeID = consumer.bldTypeID
    this.buildingName = consumer.buildingName
    this.ownerName = consumer.ownerName
    this.ddlZoneModel = consumer.zoneID
    this.ddlWardModel = consumer.wardId
    this.getZoneByProject()
    this.getWardByProject()
    this.houseNo = consumer.houseNo
    this.street = consumer.street
    this.landmark = consumer.landmark
    this.address = consumer.address
    this.shipAddress = consumer.ShippingAddress
    this.pin = consumer.pin
    this.mobileNo = consumer.mobileNo
    this.altMobileNo = consumer.altMobileNo
    this.email = consumer.email
    this.BldTypName = consumer.BldTypName
    this.buildingCategoryName = consumer.buildingCategoryId
    this.selectBuildCatogeryId()
    this.UCCCategory = consumer.UccCategoryID
    this.UccCategoryID = consumer.UccCategoryID
    this.catCD = consumer.catCD
    this.UOM = consumer.UOM
    this.stdRate = consumer.stdRate
    this.billType = consumer.billType
    if (this.billType == 'Direct') {
      this.billingTypeModal = 1
    } else {
      this.billingTypeModal = 2
    }
    if (this.billType == 'Tax Invoice') {
      this.invoiceTypeModal = 1
    } else {
      this.invoiceTypeModal = 2
    }
    this.billStartDt = consumer.billStartDt

    this.mouExpiryDate = consumer.mouExpiryDate
    //this.locality=consumer.locality
    this.state = consumer.state
    this.city = consumer.city
    this.latitudeModal = consumer.lat
    this.longitudeModal = consumer.lng
    this.gstinModal = consumer.GSTIN
    this.poNumber = consumer.poNumber
    this.poDate = consumer.poDate
    this.pan = consumer.pan
    this.verifyStatus = consumer.verifyStatus
    if (this.verifyStatus == 'Verified') {
      this.verifiedStatusModal = 1
    } else {
      this.verifiedStatusModal = 2
    }
    this.uomDataModal = consumer.UOM
    if (this.uomDataModal == null) {
      this.agreedRate = consumer.agreedRate
      this.totalAgreedRate = consumer.agreedRate
      this.proAgreedRate = consumer.agreedRate
      this.proMonthlyCharge = consumer.agreedRate
    }
    if (this.uomDataModal != null) {
      this.area = consumer.area
      this.agreedRate = consumer.stdRate
      this.proAgreedRate = consumer.agreedRate
      this.totalAgreedRate = (this.area * this.proAgreedRate).toFixed(2)
      this.proMonthlyCharge = (this.area * this.agreedRate).toFixed(2)
    }
    this.filePath = consumer.filePath
    this.clientManager = consumer.CLIENTMGR
    this.distributionManager = consumer.DISTMGR
    this.serviceManager = consumer.SERVICEMGR
    if (consumer.ISBILLABLE) {
      this.isBillable = true
    } else {
      this.isBillable = false
    }
    if (consumer.ISTAXABLE) {
      this.isTaxable = true
    } else {
      this.isTaxable = false
    }
    if (consumer.ISSERVICED) {
      this.isService = true
    } else {
      this.isService = false
    }
  }

  //To save The Consumer Details
  saveConsumer() {
    if (this.isService) {
      var isService = 1
    } else {
      var isService = 0
    }

    if (this.isBillable) {
      var isBillable = 1
    } else {
      var isBillable = 0
    }

    if (this.isTaxable) {
      var isTaxable = 1
    } else {
      var isTaxable = 0
    }
    var billTypName: any
    var invoiceTypName: any
    var verifyedStatus: any
    if (this.billingTypeModal == 1) {
      billTypName = 'Direct'
    }
    if (this.billingTypeModal == 2) {
      billTypName = 'Invoice'
    }
    if (this.invoiceTypeModal == 1) {
      invoiceTypName = 'Tax Invoice'
    }
    if (this.invoiceTypeModal == 2) {
      invoiceTypName = 'Performa Invoice'
    }
    if (this.verifiedStatusModal == 1) {
      verifyedStatus = 'Verified'
    }
    if (this.verifiedStatusModal == 2) {
      verifyedStatus = 'Unverified'
    }
    if (
      this.consumerName == null ||
      this.consumerName == undefined ||
      this.consumerName == ''
    ) {
      this.chkConsumerNameAddress = true
      return
    }
    if (
      this.buildCatId == null ||
      this.buildCatId == undefined ||
      this.buildCatId == ''
    ) {
      this.requiredBldCategory = true
      return
    }
    if (
      this.UCCCategory == null ||
      this.UCCCategory == undefined ||
      this.UCCCategory == ''
    ) {
      this.requiredUccCategory = true
      return
    }
    if (
      this.billingTypeModal == null ||
      this.billingTypeModal == undefined ||
      this.billingTypeModal == ''
    ) {
      this.requiredBillType = true
      return
    }
    if (
      this.invoiceTypeModal == null ||
      this.invoiceTypeModal == undefined ||
      this.invoiceTypeModal == ''
    ) {
      this.requiredInvoiceType = true
      return
    }
    if (
      this.verifiedStatusModal == null ||
      this.verifiedStatusModal == undefined ||
      this.verifiedStatusModal == ''
    ) {
      this.requiredVeriFiedStatus = true
      return
    }
    if (this.uomDataModal != null && (this.area == null || this.area == '')) {
      this.areaRequired = true
      return
    }
    if (
      this.uomDataModal != null &&
      (this.proAgreedRate == '' || this.proAgreedRate <= 0)
    ) {
      this.agreedRateValid = true
      return
    }
    if (this.uomDataModal == null) {
      this.areaRequired = false
    }
    if (
      this.agreedRate <= 0 ||
      this.agreedRate == undefined ||
      this.agreedRate == null
    ) {
      this.agreedRateValid = true
      return
    }
    if (this.billStartDt == null) {
      this.billDateRequired = true
      return
    } else {
      this.billStartDt = moment(this.billStartDt).format('YYYY-MM-DD')
    }

    if (this.mouExpiryDate == null) {
      this.mouExpiryDate = null
    } else {
      this.mouExpiryDate = moment(this.mouExpiryDate).format('YYYY-MM-DD')
    }

    if (
      this.ddlZoneModel == null ||
      this.ddlZoneModel == '' ||
      this.ddlZoneModel == undefined
    ) {
      this.requiredZone = true
      return
    }
    if (
      this.ddlWardModel == null ||
      this.ddlWardModel == '' ||
      this.ddlWardModel == undefined
    ) {
      this.requiredWard = true
      return
    }
    if (this.address == null) {
      this.addressRequired = true
      return
    }

    var poDate
    if (this.poDate == null) {
      poDate = null
    } else {
      poDate = moment(this.poDate).format('YYYY-MM-DD')
      // poDate = moment.utc(this.poDate).format('YYYY-MM-DD');
    }

    var data = {
      Prjid: this.prjID,
      userId: this.userId,
      consumerCD: this.consumerCD,
      consumerName: this.consumerName,
      email: this.email ? this.email : null,
      mobileNo: this.mobileNo ? this.mobileNo : null,
      altMobileNo: this.altMobileNo ? this.altMobileNo : null,
      BLDTYPEID: this.bldTypeID ? this.bldTypeID : null,
      UCCCategoryID: this.UCCCategory ? this.UCCCategory : null,
      billingType: billTypName ? billTypName : null,
      custInvoiceType: invoiceTypName ? invoiceTypName : null,
      verificationStatus: verifyedStatus ? verifyedStatus : null,
      area: this.area ? this.area : 0,
      uomTypModal: this.uomDataModal ? this.uomDataModal : null,
      agreedRate: this.proAgreedRate ? this.proAgreedRate : 0,
      billStartDt: this.billStartDt,
      mouExpiryDate: this.mouExpiryDate,
      ddlZoneModel: this.ddlZoneModel ? this.ddlZoneModel : null,
      ddlWardModel: this.ddlWardModel ? this.ddlWardModel : null,
      houseNo: this.houseNo ? this.houseNo : null,
      state: this.state ? this.state : null,
      pin: this.pin ? this.pin : null,
      street: this.street ? this.street : null,
      landmark: this.landmark ? this.landmark : null,
      city: this.city ? this.city : null,
      address: this.address ? this.address : null,
      shippingaddress: this.shipAddress ? this.shipAddress : null,
      latitude: this.latitudeModal ? this.latitudeModal : null,
      longitude: this.longitudeModal ? this.longitudeModal : null,
      gstin: this.gstinModal ? this.gstinModal : null,
      poNumber: this.poNumber ? this.poNumber : null,
      poDate: poDate,
      pan: this.pan ? this.pan : null,
      refId: this.refID ? this.refID : null,
      CLIENTMGR: this.clientManager ? this.clientManager : null,
      DISTMGR: this.distributionManager ? this.distributionManager : null,
      SERVICEMGR: this.serviceManager ? this.serviceManager : null,
      ISSERVICED: isService,
      ISBILLABLE: isBillable,
      ISTAXABLE: isTaxable,
      filePath: this.filePath ? this.filePath : null,
      // isCheckedGST: this.isCheckedGST ? this.isCheckedGST : null,
      // gstTaxableMonths: this.gstTaxableMonths ? this.gstTaxableMonths : null,
    }
    this.loaderService.display(true)
    this.isConsuSavebtn = true

    console.log(data)

    this.http
      .post(environment.apiUrl + 'consumer/saveConsumerDetails', data)
      .subscribe((data) => {
        var result: any
        result = data
        var responceCode = result.status
        if (responceCode == '200') {
          this.broadcaster.broadcast('consumerSaved', '')
          this.consuSuccessMsg = true
          this.loaderService.display(false)
        }
        if (responceCode != '200') {
          this.consuSuccessMsg = false
          this.consuErrorMsg = true
          this.loaderService.display(false)
        }
        setTimeout(() => {
          this.consuSuccessMsg = false
          this.isConsuSavebtn = false

          this.isCheckedGST = ''
          this.gstTaxableMonths = ''
          this.loaderService.display(false)

          $('#ConsumerModal').modal('hide')
        }, 2500)
      })
  }

  /**
   * consumer Name required
   */
  consNameRequired(consName) {
    if (consName == null || consName == '') {
      this.chkConsumerNameAddress = true
      this.isConsuSavebtn = true
      return
    }
    if (consName != null || consName != '') {
      this.chkConsumerNameAddress = false
      this.isConsuSavebtn = false
    }
  }

  /* 
 Select Ucc category 
 */
  selectUccCategory(uccCatData) {
    if (uccCatData != null) {
      this.agreedRate = uccCatData.RATE
      this.proAgreedRate = uccCatData.RATE
      this.totalAgreedRate = uccCatData.RATE
      this.proMonthlyCharge = uccCatData.RATE
      this.uomDataModal = uccCatData.UOM
      if (this.uomDataModal != null && (this.area != null || this.area != 0)) {
        this.totalAgreedRate = (this.agreedRate * this.area).toFixed(2)
        this.proMonthlyCharge = (this.area * this.proAgreedRate).toFixed(2)
      }
      if (this.uomDataModal != null && this.area == null) {
        this.totalAgreedRate = this.agreedRate
        this.proMonthlyCharge = this.proAgreedRate
      }
    } else {
      this.requiredUccCategory = true
    }
  }

  /*
   * get area valu change
   */
  areaValueChange(value) {
    this.area = value
    if ((this.area == '' || this.area == '0') && this.uomDataModal != null) {
      this.totalAgreedRate = this.agreedRate
      this.areaRequired = true
    } else if (this.area != '' && this.uomDataModal != null) {
      this.totalAgreedRate = (this.area * this.agreedRate).toFixed(2)
      this.proMonthlyCharge = (this.area * this.proAgreedRate).toFixed(2)
      this.areaRequired = false
    }
    if (this.uomDataModal != null && this.area == '') {
      this.totalAgreedRate = this.agreedRate.toFixed(2)
      this.proMonthlyCharge = this.proAgreedRate.toFixed(2)
    }
  }

  /**
   * to chack agreed Value gr. than 0
   */
  proAgreedValueChange(agreedValue) {
    this.proAgreedRate = agreedValue
    if (this.proAgreedRate <= 0) {
      this.agreedRateValid = true
    } else if (this.proAgreedRate >= 0) {
      this.agreedRateValid = false
      if (this.area != null && this.uomDataModal != null) {
        this.proMonthlyCharge = (this.area * this.proAgreedRate).toFixed(2)
      }
      if (
        (this.area == null || this.area != null || this.area == '') &&
        this.uomDataModal == null
      ) {
        this.proMonthlyCharge = this.proAgreedRate
      }
    }
  }
  /* 
  This method is used to get the Building Catogery By Project Id 
  */
  getConsumerBuildingCategory() {
    this.busy = this.http
      .get(
        environment.apiUrl +
          'consumer/getConsumerBuildingCategoty?prjId=' +
          this.prjID,
      )
      .subscribe((data) => {
        this.buildingCatogery = data
      })
  }
  /* 
   Get Bld Type Name
  */
  getBuildingType() {
    this.busy = this.http
      .get(environment.apiUrl + 'consumer/getBuilType')
      .subscribe((data) => {
        this.buildingCatogeryType = data
      })
  }

  /* 
  This method is used to get the Building Catogery Id on change event 
  */
  selectBuildCatogeryId() {
    this.buildCatId = this.buildingCategoryName
    if (
      this.buildCatId == null ||
      this.buildCatId == undefined ||
      this.buildCatId == ''
    ) {
      this.requiredBldCategory = true
      return
    }
    if (this.buildCatId != null || this.buildCatId != undefined) {
      this.requiredBldCategory = false
      this.getConsumerBuildingType()
      this.getUccCategoryType()
    }
  }
  /* 
  Select Billing category 
  */
  selectBillingType(billType) {
    if (billType == null) {
      this.requiredBillType = true
      return
    } else {
      this.requiredBillType = false
    }
  }
  /* 
  Select Billing category 
  */
  selectInvoiceType(billType) {
    if (billType == null) {
      this.requiredInvoiceType = true
      return
    } else {
      this.requiredInvoiceType = false
    }
  }

  selectVerifiedStatus(verifiedStatus) {
    if (verifiedStatus == null) {
      this.requiredVeriFiedStatus = true
      return
    } else {
      this.requiredVeriFiedStatus = false
    }
  }

  /*
   * Get Consumer Building Type by Building Category Id
   */
  getConsumerBuildingType() {
    var buldCatId = this.buildCatId
    // this.HttpClient .get(environment.apiUrl + 'consumer/getConsumerBuildingTypeByCatId?categoryId='+buldCatId)
    // .subscribe(data =>
    //     {
    //         this.buildingCatogeryType=data;
    //         console.log("data",this.buildingCatogeryType);
    //     });
  }

  /*
   * Get Consumer Building Type by Building Category Id
   */
  getUccCategoryType() {
    var buldCatId = this.buildCatId
    this.http
      .get(
        environment.apiUrl +
          'consumer/getUccTypeByCatId?categoryId=' +
          buldCatId +
          '&prjId=' +
          this.prjID,
      )
      .subscribe((data) => {
        this.uccType = data
      })
  }

  /*
   * Mobile Number number Restrict method
   */
  public restrictNumericOnly(e) {
    let input
    var inputlen
    if (e.metaKey || e.ctrlKey) {
      return true
    }
    if (e.which === 32) {
      return false
    }
    if (e.which === 0) {
      return true
    }
    if (e.which < 33) {
      return true
    }
    input = String.fromCharCode(e.which)
    return !!/[\d\s]/.test(input)
  }

  public numericOnlyWithDecimal(e) {
    let input
    var inputlen
    if (e.metaKey || e.ctrlKey) {
      return true
    }
    if (e.which === 32) {
      return false
    }
    if (e.which === 0) {
      return true
    }
    if (e.which < 33) {
      return true
    }
    //This step for only dot means decimal entry
    if (
      (e.which != 46 || $(this).val().indexOf('.') != -1) &&
      (e.which < 48 || e.which > 57)
    ) {
      return false
    }
    input = String.fromCharCode(e.which)
    return !!/[\d\s]/.test(input)
  }

  //To check The Email Address Validations;
  onBlurToCheckEmailAddress() {
    var txtEmailData = this.email
    var atpos = txtEmailData.indexOf('@')
    var dotpos = txtEmailData.lastIndexOf('.')
    if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= txtEmailData.length) {
      if (this.email == '') {
        this.chkConsumerEmailAddress = false
      } else {
        this.chkConsumerEmailAddress = true
      }
    } else {
      this.chkConsumerEmailAddress = false
    }
  }

  /*
   * create Consumer Code
   */
  getConsumersCode() {
    var consumerCode
    var prjId = this.prjID
    var userId = this.userId
    var source = 'W'
    this.isConsuSavebtn = true
    if (
      this.consumerCD == null ||
      this.consumerCD == undefined ||
      this.consumerCD == ''
    ) {
      this.entityCodeLoaderDiv = true
      this.imgLoaderPath = '../../assets/img/loading.gif'
    }
    this.http
      .get(
        environment.apiUrl +
          'consumer/generateConsumerCode?Prjid=' +
          prjId +
          '&userId=' +
          this.userId +
          '&source=' +
          source,
      )
      .subscribe((data) => {
        var result: any
        result = data
        consumerCode = result.ConsumerCode
        if (consumerCode != null || consumerCode != undefined) {
          this.consumerCD = consumerCode
          if (
            this.consumerCD == null ||
            this.consumerCD == undefined ||
            this.consumerCD == ''
          ) {
            this.imgLoaderPath = '../../assets/img/loading.gif'
          } else {
            this.imgLoaderPath = '../../assets/img/ok.png'
            this.isConsuSavebtn = false
          }
        } else {
          this.imgLoaderPath = '../../assets/img/loading.gif'
        }
      })
  }

  /*
    get Zone By Project
 */
  getZoneByProject() {
    this.http
      .get(
        environment.apiUrl +
          'consumer/getZoneByProject?prjid=' +
          this.prjID +
          '&oemid=7',
      )
      .subscribe((data) => {
        this.ddlZoneData = data
      })
  }
  /*
     get Zone By Project
  */
  getWardByProject() {
    if (
      this.ddlZoneModel == null ||
      this.ddlZoneModel == '' ||
      this.ddlZoneModel == undefined
    ) {
      this.requiredZone = true
      return
    }
    this.requiredZone = false
    this.http
      .get(
        environment.apiUrl +
          'consumer/getZoneByProject?prjid=' +
          this.prjID +
          '&oemid=8&entityid=' +
          this.ddlZoneModel,
      )
      .subscribe((data) => {
        this.ddlWordData = data
      })
  }
  /*
    get Ward By Project
 */
  getWardIdByProject() {
    if (
      this.ddlWardModel == null ||
      this.ddlWardModel == '' ||
      this.ddlWardModel == undefined
    ) {
      this.requiredWard = true
      return
    } else if (
      this.ddlWardModel != null ||
      this.ddlWardModel != '' ||
      this.ddlWardModel != undefined
    ) {
      this.requiredWard = false
    }
  }

  //To get The locations on click on map
  public getcrmLocationsByLatLong(prjID, radious, lat, lng) {
    this.crmLoaderDiv = true
    this.imgCrmPath = '../../assets/img/loading.gif'
    this.consumerLocanotFound = false
    this.http
      .get(
        environment.apiUrl +
          'consumer/getLocationByLatlong?prjid=' +
          prjID +
          "&lat='" +
          lat +
          "'&lng='" +
          lng +
          "'&radious=" +
          radious,
      )
      .subscribe((data) => {
        this.crmLocations = data
        if (this.crmLocations.length == 0) {
          this.consumerLocanotFound = true
          this.crmLoaderDiv = false
        } else {
          this.consumerLocanotFound = false
          this.crmLoaderDiv = false
        }
      })
  }

  selectServiceManager(data) {}
  selectDistributionManager(data) {}
  selectClientManager(data) {}

  getEmploye() {
    this.http
      .get(environment.apiUrl + 'admin/getEmploye' + '?prjId=' + this.prjID)
      .subscribe((data) => {
        this.employeList = data
        // console.log(this.employeList)
      })
  }

  ngOnInit() {
    var thisRef = this
    var myOptions = {
      center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
      zoom: 13,
      panControl: true,
      styles: [
        {
          featureType: 'water',
          stylers: [{ saturation: 43 }, { lightness: -11 }, { hue: '#0088ff' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry.fill',
          stylers: [
            { hue: '#ff0000' },
            { saturation: -100 },
            { lightness: 99 },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#B36C76' }, { lightness: 4 }],
        },
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.fill',
          stylers: [{ color: '#ece2d9' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry.fill',
          stylers: [{ color: '#ccdca1' }],
        },
      ],
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
    }
    this.map = new google.maps.Map(document.getElementById('map'), myOptions)

    //firebase connectivity for image upload
    // var config = {
    //   authDomain: "ecogreen-citizen-app.firebaseapp.com",
    //   apiKey: 'AIzaSyAHMkYkbjRTa9RazdKPJjtOJrdHCZVxxYg',
    //   databaseURL: 'HttpClient s://ecogreen-citizen-app-2ad05.firebaseio.com/',
    //   storageBucket: 'ecogreen-citizen-app.appspot.com',
    //   projectId: 'ecogreen-citizen-app'
    // };

    // firebase.initializeApp(config);

    //#########To get Lat Long when click on map######
    google.maps.event.addListener(this.map, 'click', (event) => {
      var myLatLng = event.latLng
      this.lat = myLatLng.lat()
      this.lng = myLatLng.lng()
      if (this.lat && this.lng) {
        var lat = this.lat
        var lng = this.lng
        this.getcrmLocationsByLatLong(this.prjID, 500, lat, lng)
      }
    })

    //#########To get Lat Long when click on map######
    /*
        map serch box
    */
    let input = document.getElementById('pac-input')
    let searchBox = new google.maps.places.SearchBox(input)
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)
    // Bias the SearchBox results towards current map's viewport.

    var markers = []
    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    searchBox.addListener('places_changed', function (this) {
      let places = searchBox.getPlaces()
      if (places.length == 0) {
        return
      }
      // Clear out the old markers.
      markers.forEach(function (marker) {
        marker.setMap(null)
      })
      markers = []
      // For each place, get the icon, name and location.
      let bounds = new google.maps.LatLngBounds()
      places.forEach(function (place) {
        if (!place.geometry) {
          // console.log("Returned place contains no geometry");
          return
        }
        var icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25),
        }
        // Create a marker for each place.
        markers.push(
          new google.maps.Marker({
            map: thisRef.map,
            icon: icon,
            title: place.name,
            position: place.geometry.location,
          }),
        )

        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      thisRef.map.fitBounds(bounds)
    })
    this.consumerLocanotFound = true
    this.prjID = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.getConsumerBuildingCategory()
    this.getBuildingType()
    this.getZoneByProject()
    this.getEmploye()
    this.verifyStatusDetails()
  }

  checkValue(event: any) {
    this.isCheckedGST = event

    if (event == 1) {
      this.gstMonths = 'false'
      this.monthsModal = ''
    } else {
      this.gstMonths = 'true'
      this.monthsModal = ''
    }
  }

  monthsModalChange() {
    this.currentYear = moment().format('YYYY')
    this.gstTaxableMonths = this.currentYear + '-' + this.monthsModal
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/newConsumer.component.ts